<template>
  <span class="custom-file__pic">
    <img
      v-if="documentIcon"
      :src="documentIcon"
      :alt="documentType ? documentType + ' document' : 'File'"
      class="custom-file__icon"
    />
    <icon
      v-else
      :data="iconData"
      :fill="true"
      width="var(--icon-24)"
      height="var(--icon-24)"
      class="custom-file__icon"
      color="var(--monochrome05to04)"
    />
  </span>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import { DocumentType, getDocumentType, getFileIconName } from "@/helpers/fileType"
import { Getters, store } from "@/store"

const documentIcons: Record<DocumentType, string> = {
  word: require("@/assets/images/file/doc.svg"),
  excel: require("@/assets/images/file/xls.svg"),
  pdf: require("@/assets/images/file/pdf.svg"),
  powerpoint: require("@/assets/images/file/pptx.svg")
}

@Options({
  name: "FilePic"
})
export default class FilePic extends Vue {
  @Prop({
    default: false
  })
  isRemoved: boolean
  @Prop({ default: "" }) fileName: string

  get isDark() {
    return store.getters[Getters.THEME_IS_DARK] as boolean
  }

  get documentType() {
    return getDocumentType(this.fileName)
  }

  get documentIcon() {
    if (this.isRemoved) return ""

    const iconName = getFileIconName(this.fileName)
    if (iconName) {
      return require(`@/assets/images/file/${iconName}${this.isDark ? ".dark" : ""}.svg`)
    }

    if (this.documentType) return documentIcons[this.documentType]

    return require(`@/assets/images/file/unknown${this.isDark ? ".dark" : ""}.svg`)
  }

  get iconData() {
    return require(this.isRemoved ? "@icon/file-del.svg" : "@icon/file.svg")
  }
}
</script>
